import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import MultiStepProgressBar from "./MultiStepProgressBar";
import { truncateText } from "../../utils";

const DescriptionCell = ({ description, levels, progressbar, className = '' }) => {
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const stripHtmlTags = (str) => {
    if (!str) return '';
    return str.replace(/<[^>]*>/g, '');
  };

  return (
    <td className={className}>
      <div style={{ marginBottom: "8px" }}>
        {truncateText(stripHtmlTags(description), 20)}

        {description.split(" ").length > 20 && (
          <>
            <span
              onClick={handleShowModal}
              style={{ color: "blue", cursor: "pointer", marginLeft: "5px" }}
            >
              show more
            </span>
            <Modal
              show={showModal}
              onHide={handleCloseModal}
              centered
              backdrop="static"
            >
              <Modal.Header closeButton>
                <Modal.Title>Full Description</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {stripHtmlTags(description)}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        )}
      </div>

      {progressbar && (
        <div
          className="flex justify-center"
          style={{ maxWidth: "1100px", height: "40px" }}
        >
          <MultiStepProgressBar approverLevels={levels} />
        </div>
      )}
    </td>
  );
};

export default DescriptionCell;
